import http from "@seims/shared/src/services/HttpService";

var apiEndpoint = `document-repo/documents`;
var lookupEndpoint = `lookup/document-repo`;
var seacrhEndpoint = `search/document-repo/documents`;

const axiosConfigs = {
  AlterBaseURL: true,
};

const headers = {};

const getRepoDocuments = async (records) => {

  const response = await http.get(`${seacrhEndpoint}/records?records=${records}`,
    axiosConfigs
  )
  return response;
};

const getUserDocuments = async () => {
  const response = await http.get(`${apiEndpoint}/list`,
    axiosConfigs
  );
  return response;
};

const getRatificationQueue = async () => {
  const response = await http.get(`${apiEndpoint}/filter?ratified=false`,
    axiosConfigs
  );
  return response;
};
const getAllRatifiedDocuments = async (boolTrue) => {
  const response = await http.get(`${apiEndpoint}/admin-filter?ratified=${boolTrue}`,
    axiosConfigs
  );
  return response;
};

const uploadDocument = async (document) => {
  var multiPartHeaders = {
    "Content-Type": "multipart/form-data",
  };

  const response = await http.post(`${apiEndpoint}`, document,
    { headers: multiPartHeaders, ...axiosConfigs }
  );
  return response;
};

const updateDocument = async (document) => {
  var multiPartHeaders = {
    "Content-Type": "multipart/form-data",
  };

  const response = http.put(`${apiEndpoint}/uploaders`, document,
    { headers: multiPartHeaders, ...axiosConfigs }
  );
  return response;
};

const ratifyDocument = async (document) => {
  const response = http.put(`${apiEndpoint}/ratifiers`, document,
    axiosConfigs
  );
  return response;
};


const getDocumentById = async (id) => {
  const response = http.get(`${apiEndpoint}/details?id=${id}`,
    axiosConfigs
  );
  return response;
};

const downloadFile = async (id) => {
  const response = await http.get(`${apiEndpoint}/download?id=${id}`,
    { responseType: 'arraybuffer', ...axiosConfigs })
  return response;
}

const searchDownloadFile = async (id) => {
  const response = await http.get(`${seacrhEndpoint}/download?id=${id}`,
    { responseType: 'arraybuffer', ...axiosConfigs })
  return response;
}

//Delete Own document, this doesn't need a reason
const deleteOwnDocument = async (id) => {
  const response = http.delete(`${apiEndpoint}/delete/${id}`,
    axiosConfigs
  );
  return response;
};

//Delete for ratifier
const deleteDocument = async (data) => {
  const { id, notes } = data;
  const response = http.delete(`${apiEndpoint}/delete/${id}/${notes}`,
    axiosConfigs
  );
  return response;
};

//Delete for ratified records
const deleteRatifiedDocument = async (data) => {
  const { id, notes,ratified  } = data;
  const response = http.delete(`${apiEndpoint}/delete/${id}/${notes}/${ratified}`,
    axiosConfigs
  );
  return response;
};

//Disable for ratified records
const disableRatifiedDocument = async (data) => {
  const { publicationId, disabled  } = data;
  const response = http.patch(`${apiEndpoint}/disable/${publicationId}/${disabled}`,
  {headers:headers},
    axiosConfigs
  );
  return response;
};

//**/ Lookup Endpoints for document repository
const getAffiliatedOrganisations = async () => {
  const response = await http.get(`${lookupEndpoint}/organisations/affiliated?active=true`,
    axiosConfigs
  );
  return response;

};

const getFundingAgencies = async () => {
  const response = await http.get(`${lookupEndpoint}/organisations/funding?active=true`,
    axiosConfigs
  );
  return response;

};

const getDocumentCategories = async () => {
  const response = await http.get(`${lookupEndpoint}/categories`,
    axiosConfigs
  );
  return response;
};

const addDocumentCategory = async (data) => {
  const response = await http.post(`${lookupEndpoint}/categories`, data,
    axiosConfigs
  );
  return response;
};

const updateDocumentCategory = async (data) => {
  const response = await http.patch(`${lookupEndpoint}/categories?categoryId=${data?.key}`, data,
    axiosConfigs
  );
  return response;
};

const getDocumentTypes = async () => {
  const response = await http.get(`${lookupEndpoint}/publication/types`,
    axiosConfigs
  );
  return response;
};

const addDocumentType = async (data) => {
  const response = await http.post(`${lookupEndpoint}/publication/types`, data,
    axiosConfigs
  );
  return response;
};

const updateDocumentType = async (data) => {
  const response = await http.patch(`${lookupEndpoint}/publication/types?pubTypeId=${data?.id || data?.key}`, data,
    axiosConfigs
  );
  return response;
};

const getOrganisationTypes = async () => {
  const response = await http.get(`${lookupEndpoint}/dropdown-types`,
    axiosConfigs
  );
  return response;
};

const getDocumentDropdowns = async () => {
  const response = await http.get(`${lookupEndpoint}/main-lookups/grouped`,
    axiosConfigs
  );
  return response;
};

const searchDocument = async (queryData) => {
  const response = await http.get(
    `${seacrhEndpoint}/FilterSearch?${queryData}`,
    axiosConfigs)
  return response;
};

const searchDocumentDetails = async (id) => {
  const response = http.get(`${seacrhEndpoint}/publicationId?publicationId=${id}`,
    axiosConfigs
  );
  return response;
};

// Add an affiliated-organizations or funding-agency
const addOganisation = async (data) => {
  const response = await http.post(`${lookupEndpoint}/organisations`,
    data, axiosConfigs
  );
  return response;
};

// Update an affiliated-organizations or funding-agency
const updateOganisation = async (data) => {
  const response = await http.put(`${lookupEndpoint}/organisations?organizationId=${data?.key}`,
    data, axiosConfigs
  );
  return response;
};

// Activate or deactivate an affiliated-organizations or funding-agency
const activateOganisation = async (data) => {
  const response = await http.patch(`${lookupEndpoint}/organisations?organizationId=${data?.key}`,
    data, axiosConfigs
  );
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getRepoDocuments,
  getUserDocuments,
  getAllRatifiedDocuments,
  uploadDocument,
  getDocumentById,
  updateDocument,
  ratifyDocument,
  downloadFile,
  searchDownloadFile,
  deleteOwnDocument,
  deleteDocument,
  deleteRatifiedDocument,
  disableRatifiedDocument,
  getRatificationQueue,
  getAffiliatedOrganisations,
  getFundingAgencies,

  getDocumentCategories,
  addDocumentCategory,
  updateDocumentCategory,

  getDocumentTypes,
  addDocumentType,
  updateDocumentType,

  getOrganisationTypes,
  getDocumentDropdowns,
  addOganisation,
  updateOganisation,
  activateOganisation,

  searchDocumentDetails,
  searchDocument
};
